import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var quoteApiCalls = {
  loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount: status({
    mapActionToKey: function mapActionToKey(action) {
      return [action.operationType, action.brokerId, action.marketId, action.currencyId, action.investmentItemId, action.userId, action.investmentItemAmount].join("-");
    },
    types: [ActionTypes.GET_QUOTEBYOPERATIONTYPEANDBROKERIDANDCURRENCYIDANDINESTMENTITEMIDANDUSERIDANDINVESTMENTITEMAMOUNT_REQUEST, ActionTypes.GET_QUOTEBYOPERATIONTYPEANDBROKERIDANDCURRENCYIDANDINESTMENTITEMIDANDUSERIDANDINVESTMENTITEMAMOUNT_SUCCESS, ActionTypes.GET_QUOTEBYOPERATIONTYPEANDBROKERIDANDCURRENCYIDANDINESTMENTITEMIDANDUSERIDANDINVESTMENTITEMAMOUNT_FAILURE, ActionTypes.RESET_GET_QUOTEBYOPERATIONTYPEANDBROKERIDANDCURRENCYIDANDINESTMENTITEMIDANDUSERIDANDINVESTMENTITEMAMOUNT]
  })
};
export default quoteApiCalls;